import { useMemo } from "react";

interface MenuItem {
  featureflag?: string | string[];
  children?: MenuItem[];
  [key: string]: unknown;
}

export const useMenuFiltering = (
  menuItems: MenuItem[],
  isFeatureFlagEnabled: (flag: string | string[]) => boolean,
): MenuItem[] => {
  return useMemo(() => {
    return menuItems.reduce((acc: MenuItem[], item: MenuItem) => {
      if (item.featureflag && !isFeatureFlagEnabled(item.featureflag)) {
        return acc;
      }

      if (item.children) {
        const filteredChildren = item.children.reduce(
          (acc2: MenuItem[], child: MenuItem) => {
            if (!child.featureflag || isFeatureFlagEnabled(child.featureflag)) {
              acc2.push(child);
            }
            return acc2;
          },
          [],
        );

        if (filteredChildren.length > 0) {
          acc.push({ ...item, children: filteredChildren });
        }
      } else if (!item.featureflag || isFeatureFlagEnabled(item.featureflag)) {
        acc.push(item);
      }
      return acc;
    }, []);
  }, [menuItems, isFeatureFlagEnabled]);
};
